module.exports = __webpack_public_path__ + "static/media/bg.0cc6a28c.png";